<template>
  <v-app light class="no-border">
    <v-content>
      <v-container class="pa-0 fill-height" fluid>
        <v-row class="fill-height" align="space-between">
          <v-col cols="12" md="6" sm="12" lg="4" xl="4">
            <v-row class="pa-7 fill-height" align="center" justify="center">
              <v-col cols="12">
                <a href="https://www.himydata.com"
                  ><img src="@/assets/img/Logotype_Light.png" height="45px"
                /></a>

                <h1 class="thin mt-5">
                  Create your free account
                </h1>
                <h3 class="thin mb-4">
                  Already have an account ? <a href="/signin">Log in</a>
                </h3>
                <h3 v-if="companyInvitation == false" class="thin my3">
                  Invited by : {{ companyName }}
                </h3>
                <form>
                  <v-row>
                    <!-- company name field START -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="signupForm.company"
                        v-validate="'required|min:3'"
                        label="Company name"
                        :error-messages="errors.collect('company')"
                        data-vv-name="company"
                        :readonly="companyInvitation == true"
                        :disabled="companyInvitation == true"
                        required
                      />
                    </v-col>
                    <!-- company name field END -->
                    <!-- email field START -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="signupForm.email"
                        v-validate="'required|email'"
                        label="E-mail address"
                        :error-messages="errors.collect('email')"
                        data-vv-name="email"
                        :readonly="companyInvitation == true"
                        :disabled="companyInvitation == true"
                        required
                      />
                    </v-col>
                    <!-- email field END -->
                    <!-- first name field START -->
                    <v-col class="pr-2" cols="6">
                      <v-text-field
                        v-model="signupForm.first_name"
                        v-validate="'required'"
                        label="First name"
                        :error-messages="errors.collect('first_name')"
                        data-vv-name="first_name"
                        class="input-group--focused"
                        required
                      />
                    </v-col>
                    <!-- first name field END -->
                    <!-- last name field START -->
                    <v-col class="pl-2" cols="6">
                      <v-text-field
                        v-model="signupForm.last_name"
                        v-validate="'required'"
                        label="Last name"
                        :error-messages="errors.collect('last_name')"
                        data-vv-name="last_name"
                        required
                      />
                    </v-col>
                    <!-- last name field END -->
                    <!-- password field START -->
                    <v-col cols="12">
                      <password
                        v-model="signupForm.password"
                        placeholder="Please enter a Password"
                        @score="showScore"
                      />
                      {{ passwordMessage }}
                    </v-col>
                    <!-- password field END -->
                    <!-- terms and conditions checkbox START -->
                    <v-col cols="12">
                      <v-checkbox
                        v-model="signupForm.terms"
                        v-validate="'required'"
                        type="checkbox"
                        value="1"
                        label="I agree to the terms and conditions."
                        :error-messages="errors.collect('terms')"
                        data-vv-name="terms"
                        required
                        color="primary"
                      />
                    </v-col>
                    <!-- terms and conditions checkbox END -->
                    <!-- sign up button START -->
                    <v-col cols="12" class="text-center">
                      <v-btn
                        large
                        :loading="loading"
                        :disabled="loading"
                        color="primary"
                        block
                        @click.native="submit"
                      >
                        Sign up
                      </v-btn>
                    </v-col>
                    <!-- sign up button END -->
                  </v-row>
                </form>
                <!-- form END -->
              </v-col>
            </v-row>
          </v-col>
          <v-col class="bg-cover hidden-xs-only hidden-sm-only md-6 lg-8 xl-8">
            <h2 class="white--text pa-5 mt-5 text-center">
              We helps your business grow without compromise.
            </h2>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <notify />
  </v-app>
</template>
<script>
import { mapFields } from "vee-validate";
import { register } from "../../../../utils/auth";
import AccountService from "./services/AccountService";
import Password from "vue-password-strength-meter";

export default {
  metaInfo() {
    return {
      title: "Himydata"
    };
  },
  $_veeValidate: {
    validator: "new"
  },

  components: {
    Password
  },
  data: function() {
    return {
      loader: null,
      loading: false,
      companyInvitation: false,
      companyName: null,
      companyId: null,
      signupForm: {
        email: "",
        organization: "",
        first_name: "",
        last_name: "",
        company: "",
        password: "",
        invite_key: null,
        terms: null
      },
      passwordStrength: 0,
      passwordMessage: ""
    };
  },
  created: function() {
    var key = this.$route.params.key;
    if (key) {
      AccountService.invitationAcceptInvite(key, this).then(response => {
        this.signupForm.invite_key = key;
        this.companyInvitation = false;
        if (response.data.company) {
          this.companyInvitation = false;
          this.companyName = response.data.company.name;
          this.companyId = response.data.company.id;
          this.signupForm.company = this.companyName;
        }
        this.signupForm.email = response.data.email;
      });
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (this.passwordStrength < 3) {
          this.$store.commit("push", {
            msg: "password not strong enough",
            color: "error"
          });
        } else {
          if (result) {
            this.loading = true;
            var account = {
              email: this.signupForm.email,
              first_name: this.signupForm.first_name,
              last_name: this.signupForm.last_name,
              password1: this.signupForm.password,
              password2: this.signupForm.password,
              company: this.signupForm.company,
              invite_key: this.signupForm.invite_key,
              terms: this.signupForm.terms,
              privacy: this.signupForm.terms
            };

            register(this, account).then(
              response => {
                this.loading = false;
              },
              error => {
                this.loading = false;
              }
            );
          }
        }
      });
    },
    showScore(score) {
      this.passwordStrength = score;
      switch (score) {
        case 0:
          this.passwordMessage = "You know it's not good enough";
          break;
        case 1:
          this.passwordMessage = "You can do better than this";
          break;
        case 2:
          this.passwordMessage = "Just one more effort";
          break;
        case 3:
          this.passwordMessage = "Now we're good";
          break;
        case 4:
          this.passwordMessage =
            "Okay but make sure you remember that password!";
          break;
      }
    }
  }
};
</script>
<style>
.bg-cover {
  background-color: #1a1c24;
  background-position: 50% 50%;
  background-image: url(/img/hmd-signin.svg) !important;
  background-size: 50%;
}
.pa-7 {
  padding: 70px;
}

.thin {
  font-weight: 300;
}

@media only screen and (max-width: 450px) {
  .pa-7 {
    padding: 35px;
  }
}
</style>
